import React from "react";
import dayjs from "dayjs";
import { useUserStore } from '../../store/useUserStore';

const TrialAccount: React.FC = () => {
    const { user } = useUserStore();

    let daysExpiration: number = dayjs(dayjs(user?.trialExpiration)).diff(Date.now(), "day");

    if (!daysExpiration || daysExpiration < 0)
        daysExpiration = 0;

    console.log(user?.isTrialAccount);

    if (user && user.isTrialAccount.toString() == "True")
        return (<div className='text-danger text-center' style={{ width: "70%" }}>
            Your trial account will expire in <strong>{daysExpiration}</strong> days
        </div>
        );

    return <></>
}

export default TrialAccount;
